import { render } from "./TheScooterTypes.vue?vue&type=template&id=be9235b2"
import script from "./TheScooterTypes.vue?vue&type=script&lang=js"
export * from "./TheScooterTypes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__